import { render, staticRenderFns } from "./AccessRightsOld.vue?vue&type=template&id=5201e2b8"
import script from "./AccessRightsOld.vue?vue&type=script&lang=js"
export * from "./AccessRightsOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports